module.exports = {

  title: '自嗨启动器后台管理系统'
}
